<app-breadcrumbs *ngIf="auth.isAuthenticated()"></app-breadcrumbs>
<section class="form-wrapper">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <h1>{{ pageData.title }}</h1>
        <p>{{ pageData.intro }}</p>
      </div>

      <form
        *ngIf="contactForm && !contactSuccess"
        class="contact-form"
        id="contact-form"
        [formGroup]="contactForm"
        (ngSubmit)="submit($event)"
      >
        <input
          *ngIf="auth.isAuthenticated()"
          type="hidden"
          formControlName="email"
        />

        <div class="form-row" *ngIf="!auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="email">{{
                pageData.email_label || 'Email address'
              }}</label>
              <app-tooltip
                *ngIf="pageData.email_tooltip"
                id="email_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="email"
              type="text"
              name="email"
              id="email"
              [attr.placeholder]="pageData.email_placeholder"
              [class.error]="submitted && formControl['email'].errors"
            />
            <span
              class="error"
              *ngIf="
                !auth.isAuthenticated() &&
                submitted &&
                formControl['email'].errors
              "
            >
              {{ pageData.email_error }}
            </span>
          </div>
        </div>

        <div class="form-row">
          <div class="form-field select-form-field">
            <div class="label-container">
              <label for="category">{{
                pageData.category_label || 'Select a category'
              }}</label>
              <app-tooltip
                *ngIf="pageData.category_label_tooltip"
                id="category_label_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <select
              name="category"
              formControlName="category"
              id="category"
              [class.placeholder]="formControl['category'].invalid"
              [class.error]="submitted && formControl['category'].errors"
            >
              <option disabled selected hidden value="">
                {{ pageData.category_placeholder }}
              </option>
              <ng-container
                *ngFor="let category of pageData.contact_categories"
              >
                <option
                  *ngIf="shouldDisplayCategory(category)"
                  [attr.value]="category.category_name"
                >
                  {{ category.category_name }}
                </option>
              </ng-container>
            </select>
            <span
              class="error"
              *ngIf="submitted && formControl['category'].errors"
            >
              {{ pageData.category_error }}
            </span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="label-container">
              <label for="title">{{ pageData.title_label || 'Title' }}</label>
              <app-tooltip
                *ngIf="pageData.title_label_tooltip"
                id="title_label_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <input
              formControlName="title"
              type="text"
              name="title"
              id="title"
              [attr.placeholder]="pageData.title_placeholder"
              [class.error]="submitted && formControl['title'].errors"
            />
            <span
              class="error"
              *ngIf="
                (submitted || formControl['title'].dirty) &&
                formControl['title'].errors
              "
            >
              {{ pageData.title_error }}
            </span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-field">
            <div class="label-container">
              <label for="message">{{
                pageData.message_label || 'Your message'
              }}</label>
              <app-tooltip
                *ngIf="pageData.message_label_tooltip"
                id="message_label_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <textarea
              formControlName="message"
              type="text"
              name="message"
              id="message"
              [attr.placeholder]="pageData.message_placeholder"
              [class.error]="submitted && formControl['message'].errors"
              maxlength="2000"
            ></textarea>
            <p class="textarea-counter">{{ messageCounter }}/2000</p>
            <span
              class="error"
              *ngIf="submitted && formControl['message'].errors"
            >
              {{ pageData.message_error }}
            </span>
          </div>
        </div>

        <button
          class="button contact-button"
          type="submit"
          form="contact-form"
          [class.button-loading]="
            submitted && contactForm.valid && !contactSuccess && !contactError
          "
        >
          <span>{{ pageData.button_text || 'Submit' }}</span>
        </button>
      </form>
      <app-success-block
        class="contact-success"
        *ngIf="submitted && contactSuccess"
      >
        {{ pageData.success_message || 'Message sent' }}
      </app-success-block>

      <div class="error-block-container" *ngIf="submitted && contactError">
        <app-error-block>
          {{
            pageData.error_message ||
              'Sorry, there was an error sending your message.'
          }}<br />
          <ng-container *ngIf="contactErrorMessage">
            {{ contactErrorMessage }}
          </ng-container>
        </app-error-block>
      </div>
    </div>

    <div class="cover-container" *ngIf="pageData?.cover_image">
      <img
        [src]="pageData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>

  <app-modal [(show)]="showTooltipModal" [showBuddy]="false">
    <app-tooltip-modal [content]="tooltipModalContent"></app-tooltip-modal>
  </app-modal>
</section>
